// extracted by mini-css-extract-plugin
module.exports = {"td":"Cell_td__14l8B","th":"Cell_th__10ZNI"};